import '../App.css'
import Navigation from '../componets/Navigation'
import Footer from '../componets/Footer'
import './repeat.css'

function Ofiarodawcy(){
    return (
        <>
            <Navigation />
            <div className='article'>
                <div className='title'>OFIARA  NA POTRZEBY  KOŚCIOŁA MARZEC 2025</div>
                <table>
                    <thead>
                        <tr>
                            <th>Imię Nazwisko Adres</th>
                            <th>kwota</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr><td>1.     Brzeźniak – Łowiczki Graniczna 38</td><td>100zł </td></tr>
                <tr><td>2.     A.R.Chojna – Łowiczki Centralna</td><td>100zł </td></tr>
                <tr><td>3.     Dorota Dąbrowska – Łowiczki</td><td>100zł </td></tr>
                <tr><td>4.     Halina Marek Dąbrowscy – Łowiczki Centralna 228</td><td>100zł </td></tr>
                <tr><td>5.     Renata Tomasz Drzyżdżyk – Łowiczki</td><td>100zł </td></tr>
                <tr><td>6.     T.Z.Dyrda – Łowiczki</td><td>100zł </td></tr>
                <tr><td>7.     A.B.Głąb – Łowiczki</td><td>100zł </td></tr>
                <tr><td>8.     A.S.Głąb – Łowiczki</td><td>100zł </td></tr>
                <tr><td>9.     J.J.Głąb – Łowiczki</td><td>100zł </td></tr>
                <tr><td>10. Maria Głąb – Łowiczki Centralna 80</td><td>100zł </td></tr>
                <tr><td>11. L.P.Gurdek – Łowiczki Centralna 212</td><td>100zł </td></tr>
                <tr><td>12. Helena Jurkowska – Łowiczki Centralna 212</td><td>100zł </td></tr>
                <tr><td>13. Dorota Leszek Majkut – Łowiczki</td><td>100zł </td></tr>
                <tr><td>14. Elżbieta Stanisław Matla – Łowiczki</td><td>300zł </td></tr>
                <tr><td>15. Krystyna Matla – Łowiczki</td><td>100zł </td></tr>
                <tr><td>16. W.A.Matla – Łowiczki Jodłowa</td><td>100zł </td></tr>
                <tr><td>17. Józef Miętka – Łowiczki</td><td>100zł </td></tr>
                <tr><td>18. Migdałek – Łowiczki Centralna 202</td><td>200zł </td></tr>
                <tr><td>19. Renata Pękala – Łowiczki Kanada 12</td><td>100zł </td></tr>
                <tr><td>20. M.J.Seremet – Łowiczki</td><td>200zł </td></tr>
                <tr><td>21. H.K.Stachura – Łowiczki</td><td>100zł </td></tr>
                <tr><td>22. B.A.Wojtaszek – Łowiczki</td><td>100zł </td></tr>
                <tr><td>23. C.P.Woźniak – Łowiczki Centralna 85</td><td>100zł </td></tr>
                <tr><td>24. Bogusława Zając – Łowiczki</td><td>50zł </td></tr>
                <tr><td>25. Bronisława Antecka – Andrychowska 113</td><td>100zł </td></tr>
                <tr><td>26. J.A.Anteccy – Kasztanowa 102</td><td>100zł </td></tr>
                <tr><td>27. M.L.Antecki – Andrychowska 13</td><td>100zł </td></tr>
                <tr><td>28. Augustyn – Modrzewiowa</td><td>50zł </td></tr>
                <tr><td>29. Bernaś, Momot – Akacjowa 31</td><td>100zł </td></tr>
                <tr><td>30. Mieczysław Bernaś – Modrzewiowa 47</td><td>100zł </td></tr>
                <tr><td>31. M.S.Boba – Andrychowska 352</td><td>200zł </td></tr>
                <tr><td>32. L.W.Borowscy – Andrychowska 307</td><td>100zł </td></tr>
                <tr><td>33. Brusik – Andrychowska 280</td><td>100zł </td></tr>
                <tr><td>34. M.G.Całus</td><td>100zł </td></tr>
                <tr><td>35. B.B.Cuber</td><td>100zł </td></tr>
                <tr><td>36. K.Domider – Andrychowska 216</td><td>100zł </td></tr>
                <tr><td>37. Frączek – Andrychowska 157</td><td>100zł </td></tr>
                <tr><td>38. Frączek – Andrychowska 265</td><td>100zł </td></tr>
                <tr><td>39. Anna Frączek – Wrzosowa 22</td><td>100zł </td></tr>
                <tr><td>40. B.Frączek – Modrzewiowa 2</td><td>100zł </td></tr>
                <tr><td>41. C.S.Frączek – Kasztanowa 134</td><td>100zł </td></tr>
                <tr><td>42. D.Frączek – Kasztanowa 74</td><td>100zł </td></tr>
                <tr><td>43. I.S.Frączek – Andrychowska 163</td><td>100zł </td></tr>
                <tr><td>44. M.R.Frączek – Andrychowska 227</td><td>100zł </td></tr>
                <tr><td>45. T.J.Fraączek</td><td>100zł </td></tr>
                <tr><td>46. B.J.Gagracz – Węglarzówka 11</td><td>200zł </td></tr>
                <tr><td>47. Krystyna Gagracz – Kasztanowa 130</td><td>100zł </td></tr>
                <tr><td>48. Marcin Gagracz – Akacjowa 96</td><td>100zł </td></tr>
                <tr><td>49. Marta Gagracz – Kasztanowa 132</td><td>100zł </td></tr>
                <tr><td>50. Czesława Gluzicka – Akacjowa 86</td><td>50zł </td></tr>
                <tr><td>51. Józef Głąb – Modrzewiowa</td><td>200zł </td></tr>
                <tr><td>52. W.M.Gorzkowscy</td><td>100zł </td></tr>
                <tr><td>53. Góreccy – Akacjowa 44</td><td>100zł </td></tr>
                <tr><td>54. A.Górecki – Andrychowska 69</td><td>200zł </td></tr>
                <tr><td>55. Grochal – Akacjowa</td><td>200zł </td></tr>
                <tr><td>56. Gryska, Hałat – Andrychowska 305</td><td>100zł </td></tr>
                <tr><td>57. Hałatek – Lipowa</td><td>100zł </td></tr>
                <tr><td>58. R.L.Janik – Pagórkowa 19</td><td>100zł </td></tr>
                <tr><td>59. Piotr Marcin Jureccy – Andrychowska 2</td><td>100zł </td></tr>
                <tr><td>60. Kalman – Kasztanowa 45</td><td>100zł </td></tr>
                <tr><td>61. Stanisława Kolasa – Andrychowska 171</td><td>100zł </td></tr>
                <tr><td>62. S.A.Kolasa – Andrychowska 173</td><td>100zł </td></tr>
                <tr><td>63. Kołodziej – Lipowa 59</td><td>100zł </td></tr>
                <tr><td>64. Kozak – Kasztanowa 5</td><td>100zł </td></tr>
                <tr><td>65. E.P.Kozak – Andrychowska 233</td><td>100zł </td></tr>
                <tr><td>66. Janusz Rozalia Kozłowscy – Wrzosowa 22</td><td>50zł </td></tr>
                <tr><td>67. A.K.Krawczyk – Akacjowa</td><td>100zł </td></tr>
                <tr><td>68. K.K.Krzaczyńscy – Kasztanowa 95</td><td>50zł </td></tr>
                <tr><td>69. B.Kubas – Andrychowska 380</td><td>50zł </td></tr>
                <tr><td>70. T.J.Kusak – Andrychowska 238</td><td>100zł </td></tr>
                <tr><td>71. Jerzy Kuska – Lipowa 73</td><td>100zł </td></tr>
                <tr><td>72. Leszek Kuska – Kasztanowa 2</td><td>100zł </td></tr>
                <tr><td>73. Stanisław Kuska – Kasztanowa 4</td><td>100zł </td></tr>
                <tr><td>74. Kuśpik – Andrychowska 174</td><td>100zł </td></tr>
                <tr><td>75. Kuśpik, Kalman – Andrychowska 176</td><td>100zł </td></tr>
                <tr><td>76. B.A.Kuwik – Lipowa 57</td><td>100zł </td></tr>
                <tr><td>77. W.M. - Andrychowska 65</td><td>100zł </td></tr>
                <tr><td>78. Katarzyna Rafał Madeja – Andrychowska 296</td><td>200zł </td></tr>
                <tr><td>79. Makuch – Andrychowska 134</td><td>100zł </td></tr>
                <tr><td>80. Makuch – Andrychowska 288</td><td>100zł </td></tr>
                <tr><td>81. Danuta Makuch – Andrychowska 232</td><td>100zł </td></tr>
                <tr><td>82. Józef Makuch – Akacjowa</td><td>100zł </td></tr>
                <tr><td>83. Sebastian Makuch</td><td>300zł </td></tr>
                <tr><td>84. Waldemar Makuch – Akacjowa</td><td>100zł </td></tr>
                <tr><td>85. A.P.Malik – Modrzewiowa 21</td><td>50zł </td></tr>
                <tr><td>86. Antoni Mamoń – Andrychowska 131</td><td>50zł </td></tr>
                <tr><td>87. Maria Marsowicz – Andrychowska 155</td><td>70zł </td></tr>
                <tr><td>88. Czesław Matyjasik – Kasztanowa 85</td><td>200zł </td></tr>
                <tr><td>89. Michalska – Andrychowska </td><td>200zł </td></tr>
                <tr><td>90. Karolina Mirek – Lipowa 40</td><td>100zł </td></tr>
                <tr><td>91. Mitoraj – Wrzosowa 29</td><td>100zł </td></tr>
                <tr><td>92. S.E.Młynarczyk – Akacjowa 56</td><td>100zł </td></tr>
                <tr><td>93. K.E.Nocula – Andrychowska 346</td><td>100zł </td></tr>
                <tr><td>94. Marianna Nowak – Modrzewiowa 34</td><td>50zł </td></tr>
                <tr><td>95. Wiktoria Noworyta</td><td>50zł </td></tr>
                <tr><td>96. E.Nykiel – Lipowa 72</td><td>100zł </td></tr>
                <tr><td>97. D.K.Pieczonka – Andrychowska 171</td><td>100zł </td></tr>
                <tr><td>98. Płonka – Andrychowska 299</td><td>100zł </td></tr>
                <tr><td>99. Krystian Urszula Poręba</td><td>50zł </td></tr>
                <tr><td>100.                   W.S.Poręba</td><td>100zł </td></tr>
                <tr><td>101.                   Rozalia Rola – Andrychowska 225</td><td>200zł </td></tr>
                <tr><td>102.                   E.M.Skawina – Modrzewiowa 10</td><td>100zł </td></tr>
                <tr><td>103.                   Jadwiga Stanisławek – Akacjowa</td><td>100zł </td></tr>
                <tr><td>104.                   Szatan – Andrychowska 272</td><td>100zł </td></tr>
                <tr><td>105.                   A.A.Środa – Akacjowa 77</td><td>100zł </td></tr>
                <tr><td>106.                   M.R.Tobiczyk – Andrychowska 97</td><td>100zł </td></tr>
                <tr><td>107.                   Gabriela Toporek</td><td>100zł </td></tr>
                <tr><td>108.                   Jarosław Wanat – Lipowa 41</td><td>100zł </td></tr>
                <tr><td>109.                   M.W.Wasztyl</td><td>100zł </td></tr>
                <tr><td>110.                   Łukasz Wiśniecki – Lipowa 43</td><td>100zł </td></tr>
                <tr><td>111.                   Wnętrzak</td><td>200zł </td></tr>
                <tr><td>112.                   Wojtala – Andrychowska 172</td><td>50zł </td></tr>
                <tr><td>113.                   K.Z. - Pagórkowa</td><td>200zł </td></tr>
                <tr><td>114.                   Zaczyk – Lipowa 37</td><td>100zł </td></tr>
                <tr><td>115.                   A.C.Zając – Andrychowska 111</td><td>100zł </td></tr>
                <tr><td>116.                   J.Zając – Andrychowska 320</td><td>100zł </td></tr>
                <tr><td>117.                   J.K.Zając – Andrychowska 101</td><td>100zł </td></tr>
                <tr><td>118.                   I.Ł.Zaporowscy – Andrychowska 366</td><td>100zł </td></tr>
                <tr><td>119.                   W.Zarzycki – Andrychowska 312</td><td>300zł </td></tr>
                <tr><td>120.                   Zdżalik – Wrzosowa 25</td><td>50zł </td></tr>
                <tr><td>121.                   A.Ł.Zięba – Andrychowska 351</td><td>200zł </td></tr>
                <tr><td>122.                   Józef Zimnal – Kasztanowa 111</td><td>100zł </td></tr>
                <tr><td>123.                   Akacjowa 23</td><td>100zł </td></tr>
                <tr><td>124.                   Andrychowska 32</td><td>200zł </td></tr>
                <tr><td>125.                   Andrychowska 164</td><td>200zł </td></tr>
                <tr><td>126.                   Andrychowska 167</td><td>100zł </td></tr>
                <tr><td>127.                   Andrychowska 245</td><td>100zł </td></tr>
                <tr><td>128.                   Andrychowska 260</td><td>100zł </td></tr>
                <tr><td>129.                   Andrychowska 270</td><td>50zł </td></tr>
                <tr><td>130.                   Andrychowska 301</td><td>100zł </td></tr>
                <tr><td>131.                   Andrychowska 338</td><td>50zł </td></tr>
                <tr><td>132.                   Andrychowska 408</td><td>200zł </td></tr>
                <tr><td>133.                   Jaśminowa 16</td><td>100zł </td></tr>
                <tr><td>134.                   Lipowa 61</td><td>100zł </td></tr>
                <tr><td>135.                   Wrzosowa 27</td><td>50zł </td></tr>
                <tr><td>136.                   Anonimowo</td><td>200zł </td></tr>

                    </tbody>
                </table>
            </div>

            <Footer />
        </>
)}

export default Ofiarodawcy